import styles from './CampaignWindow.module.css';

const dateFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export function CampaignWindow({ range }: { range: { start: string; end: string; weeks: number } }) {
  return (
    <div className={styles.bar}>
      <span className={styles.label}>Campaign window</span>
      <div className={styles.field}>
        <span className="mono">{dateFmt.format(new Date(range.start))}</span>
        <span className="muted">→</span>
        <span className="mono">{dateFmt.format(new Date(range.end))}</span>
      </div>
      <span className={styles.note}>· {range.weeks} weeks</span>
    </div>
  );
}
